import { useTheme } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import { useSearch } from 'src/contexts/SearchContext';

type InputSearchProps = {
  onOpen: () => void;
};

export function InputSearch({ onOpen }: InputSearchProps) {
  const theme = useTheme();
  const background = theme.palette.background.elevationSolid[8];
  const { searchQuery, setSearchQuery } = useSearch();
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  //TODO: implement searchbar functionality
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        border: 'double 1.5px transparent',
        borderRadius: '40px',
        backgroundImage: `linear-gradient(${background}, ${background}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        height: '40px',
        zIndex: 2,
        flexGrow: 1,
        boxShadow: theme.shadowsHard.primaryElevation1,
      }}
    >
      <SearchIcon sx={{ ml: 4 }} />
      <InputBase
        onClick={onOpen}
        value={searchQuery}
        onChange={handleSearchChange}
        color="primary"
        placeholder="Search..."
        sx={{
          flex: 1,
          color: 'white',
          ml: 1,
          height: '100%',
        }}
      />
    </Box>
  );
}
